import { render, staticRenderFns } from "./BonusCalc.vue?vue&type=template&id=1ae02bf0&scoped=true&"
import script from "./BonusCalc.vue?vue&type=script&lang=js&"
export * from "./BonusCalc.vue?vue&type=script&lang=js&"
import style0 from "./BonusCalc.vue?vue&type=style&index=0&id=1ae02bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae02bf0",
  null
  
)

export default component.exports